module.exports = __webpack_public_path__ + "img/1 (66).f86b215a.png";